// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DailyProfilesTable-module__font-s-10___JTzmG {
  font-size: 10px !important;
}

.DailyProfilesTable-module__font-s-12___v2Vj3 {
  font-size: 12px !important;
}

.DailyProfilesTable-module__font-s-13___E5R7l {
  font-size: 13px !important;
}

.DailyProfilesTable-module__font-s-14___rKzpG {
  font-size: 14px !important;
}

.DailyProfilesTable-module__font-s-15___fmOCy {
  font-size: 15px !important;
}

.DailyProfilesTable-module__font-s-16___ROmB1 {
  font-size: 16px !important;
}

.DailyProfilesTable-module__font-s-18___AGSv6 {
  font-size: 18px !important;
}

.DailyProfilesTable-module__font-s-20___hiPVG {
  font-size: 20px !important;
}

.DailyProfilesTable-module__font-s-22___Mgoc4 {
  font-size: 22px !important;
}

.DailyProfilesTable-module__font-s-28___TUVb4 {
  font-size: 28px !important;
}

.DailyProfilesTable-module__font-w-400___Ub50D {
  font-weight: 400 !important;
}

.DailyProfilesTable-module__font-w-500___c7JuJ {
  font-weight: 500 !important;
}

.DailyProfilesTable-module__font-w-600___W7k7G {
  font-weight: 600 !important;
}

.DailyProfilesTable-module__font-w-700___tbT4B {
  font-weight: 700 !important;
}

.DailyProfilesTable-module__p-5___zcGo8 {
  padding: 5px !important;
}

.DailyProfilesTable-module__p-12___g68yB {
  padding: 12px !important;
}

.DailyProfilesTable-module__p-16___aFhBK {
  padding: 16px !important;
}

.DailyProfilesTable-module__p-30___zJ7fe {
  padding: 30px !important;
}

.DailyProfilesTable-module__p-b-0___MOngy {
  padding-bottom: 0 !important;
}

.DailyProfilesTable-module__p-b-5___PVQtd {
  padding-bottom: 5px !important;
}

.DailyProfilesTable-module__p-b-10___S6DTc {
  padding-bottom: 10px !important;
}

.DailyProfilesTable-module__p-b-12___vRI44 {
  padding-bottom: 12px !important;
}

.DailyProfilesTable-module__p-b-16___mF4rK {
  padding-bottom: 16px !important;
}

.DailyProfilesTable-module__p-b-18___nkq_x {
  padding-bottom: 18px !important;
}

.DailyProfilesTable-module__p-b-20___DiNIx {
  padding-bottom: 20px !important;
}

.DailyProfilesTable-module__p-b-25___iQKh_ {
  padding-bottom: 25px !important;
}

.DailyProfilesTable-module__p-b-30___WNfso {
  padding-bottom: 30px !important;
}

.DailyProfilesTable-module__p-b-50___T27jE {
  padding-bottom: 50px !important;
}

.DailyProfilesTable-module__p-t-0___LJ2q8 {
  padding-top: 0 !important;
}

.DailyProfilesTable-module__p-t-12___jIxC_ {
  padding-top: 12px !important;
}

.DailyProfilesTable-module__p-t-16___TNWLu {
  padding-top: 16px !important;
}

.DailyProfilesTable-module__p-t-18___VUyxi {
  padding-top: 18px !important;
}

.DailyProfilesTable-module__p-t-20___wl8js {
  padding-top: 20px !important;
}

.DailyProfilesTable-module__p-t-30___TMANg {
  padding-top: 30px !important;
}

.DailyProfilesTable-module__p-t-40___IwAhy {
  padding-top: 40px !important;
}

.DailyProfilesTable-module__p-t-50___Gau9T {
  padding-top: 50px !important;
}

.DailyProfilesTable-module__p-l-20___VL5Pb {
  padding-left: 20px !important;
}

.DailyProfilesTable-module__p-l-30___dNJoM {
  padding-left: 30px !important;
}

.DailyProfilesTable-module__p-l-40___WfP2G {
  padding-left: 40px !important;
}

.DailyProfilesTable-module__p-r-16___R4FN9 {
  padding-right: 16px !important;
}

.DailyProfilesTable-module__p-r-20___TqXzs {
  padding-right: 20px !important;
}

.DailyProfilesTable-module__p-r-30___c7sdS {
  padding-right: 30px !important;
}

.DailyProfilesTable-module__p-r-50___qu17Z {
  padding-right: 50px !important;
}

.DailyProfilesTable-module__p-r-60___PYPzm {
  padding-right: 60px !important;
}

.DailyProfilesTable-module__m-b-1___x6vc7 {
  margin-bottom: 1px !important;
}

.DailyProfilesTable-module__m-b-2___iJhTU {
  margin-bottom: 2px !important;
}

.DailyProfilesTable-module__m-b-6___Ix5iI {
  margin-bottom: 6px !important;
}

.DailyProfilesTable-module__m-b-8___TFepM {
  margin-bottom: 8px !important;
}

.DailyProfilesTable-module__m-b-10___is0_0 {
  margin-bottom: 10px !important;
}

.DailyProfilesTable-module__m-b-14___ugcK4 {
  margin-bottom: 14px !important;
}

.DailyProfilesTable-module__m-b-16___GCeel {
  margin-bottom: 16px !important;
}

.DailyProfilesTable-module__m-b-20___RavIX {
  margin-bottom: 20px !important;
}

.DailyProfilesTable-module__m-b-22___GqNT1 {
  margin-bottom: 22px !important;
}

.DailyProfilesTable-module__m-b-24___FytxY {
  margin-bottom: 24px !important;
}

.DailyProfilesTable-module__m-b-30___cUwwc {
  margin-bottom: 30px !important;
}

.DailyProfilesTable-module__m-b-32___Wcy70 {
  margin-bottom: 32px !important;
}

.DailyProfilesTable-module__m-b-40___dvi05 {
  margin-bottom: 40px !important;
}

.DailyProfilesTable-module__m-t-2___bXmO_ {
  margin-top: 2px !important;
}

.DailyProfilesTable-module__m-t-3___LJd7s {
  margin-top: 3px !important;
}

.DailyProfilesTable-module__m-t-4___wwCSG {
  margin-top: 4px !important;
}

.DailyProfilesTable-module__m-t-5___Q1X5L {
  margin-top: 5px !important;
}

.DailyProfilesTable-module__m-t-8___doZiN {
  margin-top: 8px !important;
}

.DailyProfilesTable-module__m-t-10___ciYI0 {
  margin-top: 10px !important;
}

.DailyProfilesTable-module__m-t-15___EYaa7 {
  margin-top: 15px !important;
}

.DailyProfilesTable-module__m-t-16___g9ipc {
  margin-top: 16px !important;
}

.DailyProfilesTable-module__m-t-20___DySdR {
  margin-top: 20px !important;
}

.DailyProfilesTable-module__m-t-22___IwhDI {
  margin-top: 22px !important;
}

.DailyProfilesTable-module__m-t-30___L47TV {
  margin-top: 30px !important;
}

.DailyProfilesTable-module__m-t-32___iU8LF {
  margin-top: 32px !important;
}

.DailyProfilesTable-module__m-l-auto___wLfBW {
  margin-left: auto !important;
}

.DailyProfilesTable-module__m-l-4___tdz9q {
  margin-left: 4px !important;
}

.DailyProfilesTable-module__m-l-5___NzEOe {
  margin-left: 5px !important;
}

.DailyProfilesTable-module__m-l-6___uaYY9 {
  margin-left: 6px !important;
}

.DailyProfilesTable-module__m-l-8___ull8l {
  margin-left: 8px !important;
}

.DailyProfilesTable-module__m-l-10___jjMfz {
  margin-left: 10px !important;
}

.DailyProfilesTable-module__m-l-16___cX5gX {
  margin-left: 16px !important;
}

.DailyProfilesTable-module__m-l-20___mOWLd {
  margin-left: 20px !important;
}

.DailyProfilesTable-module__m-l-24___j6Ffr {
  margin-left: 24px !important;
}

.DailyProfilesTable-module__m-l-30___QhErX {
  margin-left: 30px !important;
}

.DailyProfilesTable-module__m-l-35___lzCKa {
  margin-left: 35px !important;
}

.DailyProfilesTable-module__m-l-40___qvV_t {
  margin-left: 40px !important;
}

.DailyProfilesTable-module__m-r-8___x5Le0 {
  margin-right: 8px !important;
}

.DailyProfilesTable-module__m-r-10___JQEfb {
  margin-right: 10px !important;
}

.DailyProfilesTable-module__m-r-16___hgef6 {
  margin-right: 16px !important;
}

.DailyProfilesTable-module__m-r-20___LiTjp {
  margin-right: 20px !important;
}

.DailyProfilesTable-module__m-r-24___a69lj {
  margin-right: 24px !important;
}

.DailyProfilesTable-module__m-r-30___iUhcL {
  margin-right: 30px !important;
}

.DailyProfilesTable-module__m-r-40___DqECR {
  margin-right: 40px !important;
}

.DailyProfilesTable-module__border-r-3___rq5_k {
  border-radius: 3px !important;
}

.DailyProfilesTable-module__border-r-4___Oa5pJ {
  border-radius: 4px !important;
}

.DailyProfilesTable-module__border-r-6___I_Nau {
  border-radius: 6px !important;
}

.DailyProfilesTable-module__border-r-10___XkMNH {
  border-radius: 10px !important;
}

.DailyProfilesTable-module__border-r-12___Ym4NE {
  border-radius: 12px !important;
}

.DailyProfilesTable-module__border-r-16___u5lMP {
  border-radius: 16px !important;
}

.DailyProfilesTable-module__border-r-50___qIsox {
  border-radius: 50% !important;
}

.DailyProfilesTable-module__primary-border___Jya3h {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.DailyProfilesTable-module__primary-border-b___av5ZZ {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.DailyProfilesTable-module__primary-border-t___tIoZL {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.DailyProfilesTable-module__primary-border-l___pBaDf {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.DailyProfilesTable-module__primary-border-r___T2J5_ {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.DailyProfilesTable-module__secondary-border___VnqcO {
  border: 1px solid #637768;
}

.DailyProfilesTable-module__secondary-border-b___UEJl8 {
  border-bottom: 1px solid #637768;
}

.DailyProfilesTable-module__secondary-border-t___D5U9c {
  border-top: 1px solid #637768;
}

.DailyProfilesTable-module__secondary-border-l___R66Z5 {
  border-left: 1px solid #637768;
}

.DailyProfilesTable-module__secondary-border-r___V8_wS {
  border-right: 1px solid #637768;
}

.DailyProfilesTable-module__gap-0___YorN7 {
  gap: 0 !important;
}

.DailyProfilesTable-module__gap-2___L57ox {
  gap: 2px !important;
}

.DailyProfilesTable-module__gap-4___IL6vN {
  gap: 4px !important;
}

.DailyProfilesTable-module__gap-5___wykhE {
  gap: 5px !important;
}

.DailyProfilesTable-module__gap-6___Y87o5 {
  gap: 6px !important;
}

.DailyProfilesTable-module__gap-8___WHT4x {
  gap: 8px !important;
}

.DailyProfilesTable-module__gap-10___g8Mix {
  gap: 10px !important;
}

.DailyProfilesTable-module__gap-12___GB6iY {
  gap: 12px !important;
}

.DailyProfilesTable-module__gap-14____m8Ur {
  gap: 14px !important;
}

.DailyProfilesTable-module__gap-16___itHpl {
  gap: 16px !important;
}

.DailyProfilesTable-module__gap-18___YzfNx {
  gap: 18px !important;
}

.DailyProfilesTable-module__gap-20___G5YCC {
  gap: 20px !important;
}

.DailyProfilesTable-module__gap-24___kbxga {
  gap: 24px !important;
}

.DailyProfilesTable-module__gap-26___QHvny {
  gap: 26px !important;
}

.DailyProfilesTable-module__gap-30___o88SC {
  gap: 30px !important;
}

.DailyProfilesTable-module__gap-32___TIJvI {
  gap: 32px !important;
}

.DailyProfilesTable-module__gap-40___EVIQP {
  gap: 40px !important;
}

.DailyProfilesTable-module__gap-50___yogdc {
  gap: 50px !important;
}

.DailyProfilesTable-module__flex-1___ah4pB {
  flex: 1;
}

.DailyProfilesTable-module__flex-none___p6mGZ {
  flex: none !important;
}

.DailyProfilesTable-module__flex-column___A6rnx {
  display: flex;
  flex-direction: column !important;
}

.DailyProfilesTable-module__flex-row___bmmuI {
  display: flex;
  flex-direction: row !important;
}

.DailyProfilesTable-module__vertically-centered___x915w {
  display: flex;
  align-items: center !important;
}

.DailyProfilesTable-module__horizontally-centered___qysiT {
  display: flex;
  justify-content: center !important;
}

.DailyProfilesTable-module__horizontally-end___UnOw1 {
  display: flex;
  justify-content: end !important;
}

.DailyProfilesTable-module__vertically-start___NVPr9 {
  display: flex;
  align-items: start !important;
}

.DailyProfilesTable-module__space-between___nMaKm {
  display: flex;
  justify-content: space-between !important;
}

.DailyProfilesTable-module__flex-wrap___ne_24 {
  flex-wrap: wrap !important;
}

.DailyProfilesTable-module__height-100___SVj58 {
  height: 100%;
}

.DailyProfilesTable-module__width-50___ZOYbE {
  width: 50% !important;
}

.DailyProfilesTable-module__width-100___SsspZ {
  width: 100%;
}

.DailyProfilesTable-module__cursor-pointer___LmPF3 {
  cursor: pointer;
}

.DailyProfilesTable-module__cursor-not-allowed___Agsh8 {
  cursor: not-allowed !important;
}

.DailyProfilesTable-module__absolute-centered___xFfm_ {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.DailyProfilesTable-module__absolute___q9DPN {
  position: absolute;
}

.DailyProfilesTable-module__relative___ieFqc {
  position: relative;
}

.DailyProfilesTable-module__fixed___ckhmH {
  position: fixed;
}

.DailyProfilesTable-module__visible___NsIyQ {
  opacity: 1;
}

.DailyProfilesTable-module__invisible___IUVth {
  opacity: 0;
}

.DailyProfilesTable-module__col-90___yqCIt {
  width: 90% !important;
}

.DailyProfilesTable-module__col-auto___w6BkH {
  width: auto !important;
}

.DailyProfilesTable-module__medical-tabs___M0Ifb {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.DailyProfilesTable-module__medical-table-new___z1Gzg {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DailyProfilesTable-module__medical-table-new___z1Gzg:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DailyProfilesTable-module__medical-table-new___z1Gzg::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DailyProfilesTable-module__medical-table-new___z1Gzg::-webkit-scrollbar-track {
  display: none;
}
.DailyProfilesTable-module__medical-table-new___z1Gzg.DailyProfilesTable-module__no-pagination___kra0h {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DailyProfilesTable-module__medical-table-new___z1Gzg.DailyProfilesTable-module__no-pagination___kra0h:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DailyProfilesTable-module__medical-table-new___z1Gzg.DailyProfilesTable-module__no-pagination___kra0h::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DailyProfilesTable-module__medical-table-new___z1Gzg.DailyProfilesTable-module__no-pagination___kra0h::-webkit-scrollbar-track {
  display: none;
}

.DailyProfilesTable-module__medical-table-empty___i3WQu {
  padding: 14px 40px !important;
}

.DailyProfilesTable-module__icon-btn___SUYQF {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.DailyProfilesTable-module__search-icon___zgrlN {
  width: 24px;
  height: 24px;
  align-self: center;
}

.DailyProfilesTable-module__disable-select___cCGcE {
  user-select: none;
}

.DailyProfilesTable-module__break-word___T2lJK {
  word-break: break-word;
}

.DailyProfilesTable-module__popup-clear-btn___qmHoc {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.DailyProfilesTable-module__scroll-m-b-20___NEdbU {
  scroll-margin-bottom: 20px;
}

.DailyProfilesTable-module__title___b9ECR {
  color: #375844;
}

.DailyProfilesTable-module__header___qstNu {
  display: grid;
  margin: 10px 0 5px 0;
  grid-template-columns: repeat(7, minmax(170px, 1fr));
}
.DailyProfilesTable-module__header___qstNu .DailyProfilesTable-module__column___MfKlV {
  color: #375844;
}

.DailyProfilesTable-module__body___WgCBv {
  display: grid;
  grid-template-columns: repeat(7, minmax(170px, 1fr));
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/tables/DailyProfilesTable/DailyProfilesTable.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,oBAAA;EACA,oDAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ;;AA1pBA;EACE,aAAA;EACA,oDAAA;AA6pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.title {\n  color: get-color(greenNew, dark);\n}\n\n.header {\n  display: grid;\n  margin: 10px 0 5px 0;\n  grid-template-columns: repeat(7, minmax(170px, 1fr));\n\n  .column {\n    color: get-color(greenNew, dark);\n  }\n}\n\n.body {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(170px, 1fr));\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `DailyProfilesTable-module__font-s-10___JTzmG`,
	"fontS12": `DailyProfilesTable-module__font-s-12___v2Vj3`,
	"fontS13": `DailyProfilesTable-module__font-s-13___E5R7l`,
	"fontS14": `DailyProfilesTable-module__font-s-14___rKzpG`,
	"fontS15": `DailyProfilesTable-module__font-s-15___fmOCy`,
	"fontS16": `DailyProfilesTable-module__font-s-16___ROmB1`,
	"fontS18": `DailyProfilesTable-module__font-s-18___AGSv6`,
	"fontS20": `DailyProfilesTable-module__font-s-20___hiPVG`,
	"fontS22": `DailyProfilesTable-module__font-s-22___Mgoc4`,
	"fontS28": `DailyProfilesTable-module__font-s-28___TUVb4`,
	"fontW400": `DailyProfilesTable-module__font-w-400___Ub50D`,
	"fontW500": `DailyProfilesTable-module__font-w-500___c7JuJ`,
	"fontW600": `DailyProfilesTable-module__font-w-600___W7k7G`,
	"fontW700": `DailyProfilesTable-module__font-w-700___tbT4B`,
	"p5": `DailyProfilesTable-module__p-5___zcGo8`,
	"p12": `DailyProfilesTable-module__p-12___g68yB`,
	"p16": `DailyProfilesTable-module__p-16___aFhBK`,
	"p30": `DailyProfilesTable-module__p-30___zJ7fe`,
	"pB0": `DailyProfilesTable-module__p-b-0___MOngy`,
	"pB5": `DailyProfilesTable-module__p-b-5___PVQtd`,
	"pB10": `DailyProfilesTable-module__p-b-10___S6DTc`,
	"pB12": `DailyProfilesTable-module__p-b-12___vRI44`,
	"pB16": `DailyProfilesTable-module__p-b-16___mF4rK`,
	"pB18": `DailyProfilesTable-module__p-b-18___nkq_x`,
	"pB20": `DailyProfilesTable-module__p-b-20___DiNIx`,
	"pB25": `DailyProfilesTable-module__p-b-25___iQKh_`,
	"pB30": `DailyProfilesTable-module__p-b-30___WNfso`,
	"pB50": `DailyProfilesTable-module__p-b-50___T27jE`,
	"pT0": `DailyProfilesTable-module__p-t-0___LJ2q8`,
	"pT12": `DailyProfilesTable-module__p-t-12___jIxC_`,
	"pT16": `DailyProfilesTable-module__p-t-16___TNWLu`,
	"pT18": `DailyProfilesTable-module__p-t-18___VUyxi`,
	"pT20": `DailyProfilesTable-module__p-t-20___wl8js`,
	"pT30": `DailyProfilesTable-module__p-t-30___TMANg`,
	"pT40": `DailyProfilesTable-module__p-t-40___IwAhy`,
	"pT50": `DailyProfilesTable-module__p-t-50___Gau9T`,
	"pL20": `DailyProfilesTable-module__p-l-20___VL5Pb`,
	"pL30": `DailyProfilesTable-module__p-l-30___dNJoM`,
	"pL40": `DailyProfilesTable-module__p-l-40___WfP2G`,
	"pR16": `DailyProfilesTable-module__p-r-16___R4FN9`,
	"pR20": `DailyProfilesTable-module__p-r-20___TqXzs`,
	"pR30": `DailyProfilesTable-module__p-r-30___c7sdS`,
	"pR50": `DailyProfilesTable-module__p-r-50___qu17Z`,
	"pR60": `DailyProfilesTable-module__p-r-60___PYPzm`,
	"mB1": `DailyProfilesTable-module__m-b-1___x6vc7`,
	"mB2": `DailyProfilesTable-module__m-b-2___iJhTU`,
	"mB6": `DailyProfilesTable-module__m-b-6___Ix5iI`,
	"mB8": `DailyProfilesTable-module__m-b-8___TFepM`,
	"mB10": `DailyProfilesTable-module__m-b-10___is0_0`,
	"mB14": `DailyProfilesTable-module__m-b-14___ugcK4`,
	"mB16": `DailyProfilesTable-module__m-b-16___GCeel`,
	"mB20": `DailyProfilesTable-module__m-b-20___RavIX`,
	"mB22": `DailyProfilesTable-module__m-b-22___GqNT1`,
	"mB24": `DailyProfilesTable-module__m-b-24___FytxY`,
	"mB30": `DailyProfilesTable-module__m-b-30___cUwwc`,
	"mB32": `DailyProfilesTable-module__m-b-32___Wcy70`,
	"mB40": `DailyProfilesTable-module__m-b-40___dvi05`,
	"mT2": `DailyProfilesTable-module__m-t-2___bXmO_`,
	"mT3": `DailyProfilesTable-module__m-t-3___LJd7s`,
	"mT4": `DailyProfilesTable-module__m-t-4___wwCSG`,
	"mT5": `DailyProfilesTable-module__m-t-5___Q1X5L`,
	"mT8": `DailyProfilesTable-module__m-t-8___doZiN`,
	"mT10": `DailyProfilesTable-module__m-t-10___ciYI0`,
	"mT15": `DailyProfilesTable-module__m-t-15___EYaa7`,
	"mT16": `DailyProfilesTable-module__m-t-16___g9ipc`,
	"mT20": `DailyProfilesTable-module__m-t-20___DySdR`,
	"mT22": `DailyProfilesTable-module__m-t-22___IwhDI`,
	"mT30": `DailyProfilesTable-module__m-t-30___L47TV`,
	"mT32": `DailyProfilesTable-module__m-t-32___iU8LF`,
	"mLAuto": `DailyProfilesTable-module__m-l-auto___wLfBW`,
	"mL4": `DailyProfilesTable-module__m-l-4___tdz9q`,
	"mL5": `DailyProfilesTable-module__m-l-5___NzEOe`,
	"mL6": `DailyProfilesTable-module__m-l-6___uaYY9`,
	"mL8": `DailyProfilesTable-module__m-l-8___ull8l`,
	"mL10": `DailyProfilesTable-module__m-l-10___jjMfz`,
	"mL16": `DailyProfilesTable-module__m-l-16___cX5gX`,
	"mL20": `DailyProfilesTable-module__m-l-20___mOWLd`,
	"mL24": `DailyProfilesTable-module__m-l-24___j6Ffr`,
	"mL30": `DailyProfilesTable-module__m-l-30___QhErX`,
	"mL35": `DailyProfilesTable-module__m-l-35___lzCKa`,
	"mL40": `DailyProfilesTable-module__m-l-40___qvV_t`,
	"mR8": `DailyProfilesTable-module__m-r-8___x5Le0`,
	"mR10": `DailyProfilesTable-module__m-r-10___JQEfb`,
	"mR16": `DailyProfilesTable-module__m-r-16___hgef6`,
	"mR20": `DailyProfilesTable-module__m-r-20___LiTjp`,
	"mR24": `DailyProfilesTable-module__m-r-24___a69lj`,
	"mR30": `DailyProfilesTable-module__m-r-30___iUhcL`,
	"mR40": `DailyProfilesTable-module__m-r-40___DqECR`,
	"borderR3": `DailyProfilesTable-module__border-r-3___rq5_k`,
	"borderR4": `DailyProfilesTable-module__border-r-4___Oa5pJ`,
	"borderR6": `DailyProfilesTable-module__border-r-6___I_Nau`,
	"borderR10": `DailyProfilesTable-module__border-r-10___XkMNH`,
	"borderR12": `DailyProfilesTable-module__border-r-12___Ym4NE`,
	"borderR16": `DailyProfilesTable-module__border-r-16___u5lMP`,
	"borderR50": `DailyProfilesTable-module__border-r-50___qIsox`,
	"primaryBorder": `DailyProfilesTable-module__primary-border___Jya3h`,
	"primaryBorderB": `DailyProfilesTable-module__primary-border-b___av5ZZ`,
	"primaryBorderT": `DailyProfilesTable-module__primary-border-t___tIoZL`,
	"primaryBorderL": `DailyProfilesTable-module__primary-border-l___pBaDf`,
	"primaryBorderR": `DailyProfilesTable-module__primary-border-r___T2J5_`,
	"secondaryBorder": `DailyProfilesTable-module__secondary-border___VnqcO`,
	"secondaryBorderB": `DailyProfilesTable-module__secondary-border-b___UEJl8`,
	"secondaryBorderT": `DailyProfilesTable-module__secondary-border-t___D5U9c`,
	"secondaryBorderL": `DailyProfilesTable-module__secondary-border-l___R66Z5`,
	"secondaryBorderR": `DailyProfilesTable-module__secondary-border-r___V8_wS`,
	"gap0": `DailyProfilesTable-module__gap-0___YorN7`,
	"gap2": `DailyProfilesTable-module__gap-2___L57ox`,
	"gap4": `DailyProfilesTable-module__gap-4___IL6vN`,
	"gap5": `DailyProfilesTable-module__gap-5___wykhE`,
	"gap6": `DailyProfilesTable-module__gap-6___Y87o5`,
	"gap8": `DailyProfilesTable-module__gap-8___WHT4x`,
	"gap10": `DailyProfilesTable-module__gap-10___g8Mix`,
	"gap12": `DailyProfilesTable-module__gap-12___GB6iY`,
	"gap14": `DailyProfilesTable-module__gap-14____m8Ur`,
	"gap16": `DailyProfilesTable-module__gap-16___itHpl`,
	"gap18": `DailyProfilesTable-module__gap-18___YzfNx`,
	"gap20": `DailyProfilesTable-module__gap-20___G5YCC`,
	"gap24": `DailyProfilesTable-module__gap-24___kbxga`,
	"gap26": `DailyProfilesTable-module__gap-26___QHvny`,
	"gap30": `DailyProfilesTable-module__gap-30___o88SC`,
	"gap32": `DailyProfilesTable-module__gap-32___TIJvI`,
	"gap40": `DailyProfilesTable-module__gap-40___EVIQP`,
	"gap50": `DailyProfilesTable-module__gap-50___yogdc`,
	"flex1": `DailyProfilesTable-module__flex-1___ah4pB`,
	"flexNone": `DailyProfilesTable-module__flex-none___p6mGZ`,
	"flexColumn": `DailyProfilesTable-module__flex-column___A6rnx`,
	"flexRow": `DailyProfilesTable-module__flex-row___bmmuI`,
	"verticallyCentered": `DailyProfilesTable-module__vertically-centered___x915w`,
	"horizontallyCentered": `DailyProfilesTable-module__horizontally-centered___qysiT`,
	"horizontallyEnd": `DailyProfilesTable-module__horizontally-end___UnOw1`,
	"verticallyStart": `DailyProfilesTable-module__vertically-start___NVPr9`,
	"spaceBetween": `DailyProfilesTable-module__space-between___nMaKm`,
	"flexWrap": `DailyProfilesTable-module__flex-wrap___ne_24`,
	"height100": `DailyProfilesTable-module__height-100___SVj58`,
	"width50": `DailyProfilesTable-module__width-50___ZOYbE`,
	"width100": `DailyProfilesTable-module__width-100___SsspZ`,
	"cursorPointer": `DailyProfilesTable-module__cursor-pointer___LmPF3`,
	"cursorNotAllowed": `DailyProfilesTable-module__cursor-not-allowed___Agsh8`,
	"absoluteCentered": `DailyProfilesTable-module__absolute-centered___xFfm_`,
	"absolute": `DailyProfilesTable-module__absolute___q9DPN`,
	"relative": `DailyProfilesTable-module__relative___ieFqc`,
	"fixed": `DailyProfilesTable-module__fixed___ckhmH`,
	"visible": `DailyProfilesTable-module__visible___NsIyQ`,
	"invisible": `DailyProfilesTable-module__invisible___IUVth`,
	"col90": `DailyProfilesTable-module__col-90___yqCIt`,
	"colAuto": `DailyProfilesTable-module__col-auto___w6BkH`,
	"medicalTabs": `DailyProfilesTable-module__medical-tabs___M0Ifb`,
	"medicalTableNew": `DailyProfilesTable-module__medical-table-new___z1Gzg`,
	"noPagination": `DailyProfilesTable-module__no-pagination___kra0h`,
	"medicalTableEmpty": `DailyProfilesTable-module__medical-table-empty___i3WQu`,
	"iconBtn": `DailyProfilesTable-module__icon-btn___SUYQF`,
	"searchIcon": `DailyProfilesTable-module__search-icon___zgrlN`,
	"disableSelect": `DailyProfilesTable-module__disable-select___cCGcE`,
	"breakWord": `DailyProfilesTable-module__break-word___T2lJK`,
	"popupClearBtn": `DailyProfilesTable-module__popup-clear-btn___qmHoc`,
	"scrollMB20": `DailyProfilesTable-module__scroll-m-b-20___NEdbU`,
	"title": `DailyProfilesTable-module__title___b9ECR`,
	"header": `DailyProfilesTable-module__header___qstNu`,
	"column": `DailyProfilesTable-module__column___MfKlV`,
	"body": `DailyProfilesTable-module__body___WgCBv`
};
module.exports = ___CSS_LOADER_EXPORT___;
